import matchSorter from 'match-sorter'
import React from 'react'
import { InputSimples, InputPadrao, InputDatePicker, InputTimePicker } from './Inputs'
import {
    InputPorArray, InputSimNao, InputOperadoraSaude, InputBeneficiario,
    InputGrauDependencia,
    InputEmpresaParceira,
    InputCBOS,
    InputSituacaoAdministrativa,
    InputTipoPessoa,
    InputPrestador,
    InputBeneficiarioTitular,
    InputPrestadorConselho,
    InputPrestadorConselhoFiltro
} from './InputsAutoComplete'
import { removeAcentos } from '../util/FuncoesComuns'
import { InputConselhoProfissional } from './InputsAutoComplete'

const FiltroObjeto = (props) => {
    const tipo = props.tipo
    switch (tipo) {
        case 'combo':
            return <InputPorArray {...props} />
        case 'combo-simples':
            return <InputPorArray {...props} multiplo={false} />
        case 'texto-global':
            return <InputPadrao {...props} />
        default:
            return <></>
    }
}

const FiltroDataGrid = (props) => {
    const tipo = props.tipo;

    switch (tipo) {
        case 'data':
        case 'data_inicial':
        case 'data_final':
            return <InputDatePicker {...props} />
        case 'hora_final_registro':
            return <InputTimePicker {...props} />
        case 'input_sim_nao':
            return <InputSimNao {...props} multiplo={false} />
        case 'operadora_saude':
            return <InputOperadoraSaude {...props} />
        case 'beneficiario':
            return <InputBeneficiario {...props} multiplo={false} />
        case 'beneficiario_titular':
            return <InputBeneficiarioTitular {...props} />
        case 'grau_dependencia':
            return <InputGrauDependencia {...props} />
        case 'empresa_parceira':
            return <InputEmpresaParceira {...props} />
        case 'cbos':
            return <InputCBOS {...props} />
        case 'conselho_profissional':
            return <InputConselhoProfissional {...props} />
        case 'situacao_administrativa':
            return <InputSituacaoAdministrativa {...props} />
        case 'tipo_executante':
            return <InputTipoPessoa {...props} multiplo={false} />
        case 'prestador':
            return <InputPrestador {...props} multiplo={false} />
        case 'prestador_conselho':
            return <InputPrestadorConselho {...props} multiplo={false} />
        default:
            return <></>
    }
}

const Ordenaveis = (props) => {
    return (
        <>
            {/* <InputOrdenamento label="" name="ordenamento" placeholder="Selecione" icone="icon-A-Z" {...props} /> */}
        </>
    )
}

const filtragemPorString = (data, coluna, filtro) => {
    /*filtro pode ser string ou array de strings*/
    let cloneData = [...data]
    let arrayPesquisado = []
    if (Array.isArray(filtro)) {
        filtro.map(item => {
            arrayPesquisado = arrayPesquisado.concat(cloneData.filter(row => row[coluna] === item))
            return item
        })
        cloneData = arrayPesquisado
    } else {
        cloneData = cloneData.filter(row => row[coluna] === filtro)
        // matchSorter(cloneData, filtro, { keys: [row => row[coluna]] })
    }
    return cloneData
}

const filtragemPorStringAlternativa = (data, coluna, filtro) => {

    /*filtro pode ser string ou array de strings*/
    let cloneData = [...data]
    let arrayPesquisado = []
    if (Array.isArray(filtro)) {
        filtro.map(item => {
            arrayPesquisado = arrayPesquisado.concat(cloneData.filter(row => row[coluna] && row[coluna].includes(item)))
            return item
        })
        cloneData = arrayPesquisado
    } else {
        cloneData = cloneData.filter(row => row[coluna].includes(filtro))
        // matchSorter(cloneData, filtro, { keys: [row => row[coluna]] })
    }
    return cloneData
}

const pesquisaGlobal = (dados, colunas, texto) => {
    const retorno = dados.filter(item => {
        const row = colunas.map(coluna => item[coluna])
        return removeAcentos(row.join(' ').toLocaleLowerCase()).includes(removeAcentos(String(texto || "").toLowerCase()))
    })
    return retorno;
}

const combo = (data, coluna, filtro) => {

    if (filtro && filtro.length > 0) {
        const novoFiltro = filtro.map(item => item.label)
        return filtragemPorString(data, coluna, novoFiltro)
    }

    return data
}

const comboAlternativa = (data, coluna, filtro) => {

    if (filtro && filtro.length > 0) {

        const novoFiltro = filtro.map(item => item.label)

        return filtragemPorString(data, coluna, novoFiltro)
    }

    return data
}

const comboAlternativaPesquisa = (data, coluna, filtro) => {

    if (filtro && filtro.length > 0) {

        const novoFiltro = filtro.map(item => item.label)
        return filtragemPorStringAlternativa(data, coluna, novoFiltro)
    }

    return data
}


const comboSimples = (data, coluna, filtro) => {
    if (filtro && filtro.label)
        return filtragemPorString(data, coluna, filtro.label)

    return data
}

const textoGlobal = (data, colunas, filtro) => {
    return pesquisaGlobal(data, colunas, filtro)
}


const metodoFiltragem = {
    'combo': combo,
    'combo-simples': comboSimples,
    'texto-global': textoGlobal
}

const metodoFiltragemAlternativa = {
    'combo': comboAlternativa,
    'combo-simples': comboSimples,
    'texto-global': textoGlobal,
    'combo-alternativa': comboAlternativaPesquisa
}

const toStringFiltro = (tipo, value) => {
    switch (tipo) {
        case 'combo':
            return value.map(item => item.label).join(', ')
        case 'combo-simples':
            return value.label
        case 'texto-global':
            return value
        default:
            return value || ''
    }
}


// Define a default UI for filtering
function DefaultColumnFilter({
    column: { filterValue, preFilteredRows, setFilter },
}) {
    const count = preFilteredRows.length

    return (
        <InputSimples
            label=""
            name="search2"
            type="text"
            value={filterValue || ''}
            onChange={e => {
                setFilter(e.target.value || undefined) // Set undefined to remove the filter entirely
            }}
            placeholder={`Busca em ${count} registros...`}
        />
    )
}

// This is a custom filter UI for selecting
// a unique option from a list
function SelectColumnFilter({
    column: { filterValue, setFilter, preFilteredRows, id },
}) {
    // Calculate the options for filtering
    // using the preFilteredRows
    const options = React.useMemo(() => {
        const options = new Set()
        preFilteredRows.forEach(row => {
            options.add(row.values[id])
        })
        return [...options.values()]
    }, [id, preFilteredRows])

    // Render a multi-select box
    return (
        <select
            value={filterValue}
            onChange={e => {
                setFilter(e.target.value || undefined)
            }}
        >
            <option value="">Todos</option>
            {options.map((option, i) => (
                <option key={i} value={option}>
                    {option}
                </option>
            ))}
        </select>
    )
}

// This is a custom filter UI that uses a
// slider to set the filter value between a column's
// min and max values
function SliderColumnFilter({
    column: { filterValue, setFilter, preFilteredRows, id },
}) {
    // Calculate the min and max
    // using the preFilteredRows

    const [min, max] = React.useMemo(() => {
        let min = preFilteredRows.length ? preFilteredRows[0].values[id] : 0
        let max = preFilteredRows.length ? preFilteredRows[0].values[id] : 0
        preFilteredRows.forEach(row => {
            min = Math.min(row.values[id], min)
            max = Math.max(row.values[id], max)
        })
        return [min, max]
    }, [id, preFilteredRows])

    return (
        <>
            <input
                type="range"
                min={min}
                max={max}
                value={filterValue || min}
                onChange={e => {
                    setFilter(parseInt(e.target.value, 10))
                }}
            />
            <button onClick={() => setFilter(undefined)}>Remover Filtro</button>
        </>
    )
}

// This is a custom UI for our 'between' or number range
// filter. It uses two number boxes and filters rows to
// ones that have values between the two
function NumberRangeColumnFilter({
    column: { filterValue = [], preFilteredRows, setFilter, id },
}) {
    const [min, max] = React.useMemo(() => {
        let min = preFilteredRows.length ? preFilteredRows[0].values[id] : 0
        let max = preFilteredRows.length ? preFilteredRows[0].values[id] : 0
        preFilteredRows.forEach(row => {
            min = Math.min(row.values[id], min)
            max = Math.max(row.values[id], max)
        })
        return [min, max]
    }, [id, preFilteredRows])

    return (
        <div
            style={{
                display: 'flex',
            }}
        >
            <input
                value={filterValue[0] || ''}
                type="number"
                onChange={e => {
                    const val = e.target.value
                    setFilter((old = []) => [val ? parseInt(val, 10) : undefined, old[1]])
                }}
                placeholder={`Min (${min})`}
                style={{
                    width: '70px',
                    marginRight: '0.5rem',
                }}
            />
            to
            <input
                value={filterValue[1] || ''}
                type="number"
                onChange={e => {
                    const val = e.target.value
                    setFilter((old = []) => [old[0], val ? parseInt(val, 10) : undefined])
                }}
                placeholder={`Max (${max})`}
                style={{
                    width: '70px',
                    marginLeft: '0.5rem',
                }}
            />
        </div>
    )
}

function fuzzyTextFilterFn(rows, id, filterValue) {
    return matchSorter(rows, filterValue, { keys: [row => row.values[id]] })
}

// Let the table remove the filter if the string is empty
fuzzyTextFilterFn.autoRemove = val => !val

function filterGreaterThan(rows, id, filterValue) {
    return rows.filter(row => {
        const rowValue = row.values[id]
        return rowValue >= filterValue
    })
}

export {
    SliderColumnFilter,
    NumberRangeColumnFilter,
    SelectColumnFilter,
    filterGreaterThan,
    fuzzyTextFilterFn,
    DefaultColumnFilter,
    FiltroObjeto,
    metodoFiltragem,
    toStringFiltro, pesquisaGlobal, Ordenaveis, FiltroDataGrid, metodoFiltragemAlternativa
}